import { useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { cardOtpVerificationMutationFn, NetworkError } from "../../../../../api";
import { useEffect } from "react";
import { SMS_FORM_ERROR_MESSAGES } from "../../SMSForm/hooks";
import { useSMSFormState } from "../../SMSForm/hooks";
import { ESMSFormState } from "../../../../../store/slices/smsFormSliceCreator.ts";

const toastId = "b2p-verification-mutation";

export function useB2pOTPMutationReaction() {
  const toast = useToast();
  const smsForm = useSMSFormState();

  const verificationMutation = useMutation({
    mutationFn: cardOtpVerificationMutationFn,
  });

  useEffect(() => {
    switch (verificationMutation.status) {
      case "success": {
        smsForm.setFormState(ESMSFormState.submitted);
        // Don't navigate - stay on page and poll status directly
        return;
      }
      case "error": {
        const error = verificationMutation.error as NetworkError;
        switch (error.internalCode) {
          // 1100 - invalid code and 7000 too
          case 7000:
          case 1100: {
            smsForm.setErrorMessage(SMS_FORM_ERROR_MESSAGES.incorrect);
            smsForm.setFormState(ESMSFormState.initial);
            return;
          }
        }
        // status code is not 456 or unexpected internal code
        toast({
          id: toastId,
          description: SMS_FORM_ERROR_MESSAGES.unexpectedServerError,
        });
        smsForm.setFormState(ESMSFormState.initial);
        return;
      }
    }
  }, [verificationMutation.status]);

  return verificationMutation;
}
